import React from 'react';
import styled from 'styled-components';
import ColorConstants from '../../../constants/ColorConstants';
import FontFamilyConstants from '../../../constants/FontFamilyConstants';

const defaultProps = {
    background: ColorConstants['white-50%'],
    color: ColorConstants.white,
    label: null,
    styles: null,
};

const DismissButton = ({
    background,
    color,
    label,
    onClick,
    styles,
    ...props
}) => (
    <DismissButtonWrapper
        background={background}
        color={color}
        onClick={onClick}
        styles={styles}
        {...props}
    >
        {label}
    </DismissButtonWrapper>
);

const DismissButtonWrapper = styled.button`
    background: ${({ background }) => background || ColorConstants.white};
    color: ${({ color }) => color};
    border-radius: 22px;
    border-color: ${ColorConstants.white};
    border-style: solid;
    border-width: thin;
    min-height: 50px;
    width: 200px;
    font-family: ${FontFamilyConstants.Helvetica};
    font-weight: 300;
    
    ${({ styles }) => styles && { ...styles }};
`;

DismissButton.defaultProps = defaultProps;

export default DismissButton;
